import type { HubDatasetArtifact } from '@robovision/hub'
import { JobBaseArtifactWithoutDefinition } from './JobBaseArtifact'


export interface JobDatasetArtifactParams extends JobBaseArtifactWithoutDefinition {
  datapoolId: string
  test: boolean
}

export class JobDatasetArtifact extends JobBaseArtifactWithoutDefinition {
  public datapoolId: string
  public test: boolean

  protected constructor (params: JobDatasetArtifactParams) {
    super(params)
    this.datapoolId = params.datapoolId
    this.test = params.test
  }

  public static fromDefinition (
    datasetArtifact: HubDatasetArtifact,
  ) {
    return new JobDatasetArtifact({
      artifactId: datasetArtifact.id,
      datapoolId: datasetArtifact.datapoolId,
      description: datasetArtifact.description,
      name: datasetArtifact.name,
      test: !!datasetArtifact.test,
    })
  }
}
